"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var util_1 = __importDefault(require("@hikakaku/shared/util/util"));
var use_uncontrolled_value_sync_1 = require("@hikakaku/shared/hooks/use_uncontrolled_value_sync");
var lockIcon = require("images/lock.svg");
var CODE_LENGTH = 6;
var ResendButton = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store, onResend = _a.onResend;
    return (react_1.default.createElement("button", { className: "sms-verification-modal__container__footer__resend-button", onClick: onResend, disabled: !store.canResend }, store.resendButtonText));
});
var SmsVerificationModal = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store, onVerified = _a.onVerified;
    var dialogRef = (0, react_1.useRef)(null);
    var inputRef = (0, react_1.useRef)(null);
    (0, use_uncontrolled_value_sync_1.useUncontrolledValueSync)([
        { getElement: function () { return inputRef.current; }, value: store.verificationCode },
    ]);
    (0, react_1.useEffect)(function () {
        if (store.isModalOpen && dialogRef.current) {
            dialogRef.current.showModal();
            // Send SMS automatically when modal opens (if not sent yet)
            if (!store.otpRequested && store.phoneNumber) {
                store.sendCode(store.phoneNumber);
            }
            // Focus input when modal opens (using requestAnimationFrame for better timing)
            requestAnimationFrame(function () {
                setTimeout(function () {
                    var _a;
                    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }, 100);
            });
        }
        else if (!store.isModalOpen && dialogRef.current) {
            dialogRef.current.close();
        }
    }, [store.isModalOpen, store.phoneNumber]);
    var handleDialogClose = (0, react_1.useCallback)(function () {
        if (store.autoSubmitRequested) {
            return;
        }
        store.closeModal();
    }, [store.autoSubmitRequested, store]);
    (0, react_1.useEffect)(function () {
        var dialog = dialogRef.current;
        if (!dialog)
            return;
        dialog.addEventListener('close', handleDialogClose);
        return function () {
            dialog.removeEventListener('close', handleDialogClose);
        };
    }, [handleDialogClose]);
    (0, react_1.useEffect)(function () {
        if (store.autoSubmitRequested) {
            onVerified();
            store.completeAutoSubmitRequest();
        }
    }, [store.autoSubmitRequested, onVerified]);
    var handleCodeChange = function (e) {
        var value = util_1.default.normalizeDigits(e.target.value, CODE_LENGTH);
        store.setVerificationCode(value);
    };
    var handleCodeBlur = function (event) {
        event.target.value = util_1.default.normalizeDigits(event.target.value, CODE_LENGTH);
    };
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var verified;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, store.verifyCode()];
                case 1:
                    verified = _a.sent();
                    if (verified) {
                        onVerified();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleResend = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, store.resendCode()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var isCodeComplete = store.verificationCode.length === CODE_LENGTH;
    return (react_1.default.createElement("dialog", { ref: dialogRef, className: "sms-verification-modal", id: "sms-auth-modal" },
        react_1.default.createElement("div", { className: "sms-verification-modal__container" },
            react_1.default.createElement("div", { className: "sms-verification-modal__container__header" },
                react_1.default.createElement("p", { className: "sms-verification-modal__container__header__title" },
                    react_1.default.createElement("img", { src: lockIcon, alt: "Lock icon" }),
                    react_1.default.createElement("span", null, "SMS\u8A8D\u8A3C")),
                react_1.default.createElement("form", { method: "dialog" },
                    react_1.default.createElement("button", { className: "sms-verification-modal__container__header__close-button" },
                        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "white", className: "size-6" },
                            react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M6 18 18 6M6 6l12 12" }))))),
            react_1.default.createElement("div", { className: "sms-verification-modal__container__body" },
                react_1.default.createElement("p", { className: "sms-verification-modal__container__body__text" },
                    react_1.default.createElement("span", null, store.formattedPhoneNumber),
                    react_1.default.createElement("span", null, "\u306B\uFF33\uFF2D\uFF33\u3092"),
                    store.isResent ? (react_1.default.createElement("span", { className: "strong" }, "\u518D\u9001\u3057\u307E\u3057\u305F\u3002")) : (react_1.default.createElement("span", null, "\u304A\u9001\u308A\u3057\u307E\u3057\u305F\u3002")),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("span", null, "\u643A\u5E2F\u96FB\u8A71\u306E\uFF33\uFF2D\uFF33\uFF08\u30B7\u30E7\u30FC\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\uFF09\u3067\u53D7\u3051\u53D6\u3063\u305F"),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("span", null, "\u8A8D\u8A3C\u30B3\u30FC\u30C9\uFF086\u6841\u306E\u756A\u53F7\uFF09\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002")),
                store.errors !== null && (react_1.default.createElement("div", { className: "sms-verification-modal__container__body__error" }, typeof store.errors === "string" ? (react_1.default.createElement("p", null, store.errors)) : (Array.from(store.errors).map(function (line, idx) { return (react_1.default.createElement("p", { key: idx }, line)); })))),
                react_1.default.createElement("input", { ref: inputRef, type: "text", inputMode: "numeric", maxLength: CODE_LENGTH, defaultValue: store.verificationCode, onChange: handleCodeChange, onBlur: handleCodeBlur, className: "sms-verification-modal__container__body__input" }),
                react_1.default.createElement("button", { className: "sms-verification-modal__container__body__submit-button ".concat(isCodeComplete ? 'active' : ''), onClick: handleSubmit, disabled: store.isLoading || !isCodeComplete }, store.isLoading ? '送信中...' : '無料査定を申し込む')),
            react_1.default.createElement("div", { className: "sms-verification-modal__container__footer" },
                react_1.default.createElement(ResendButton, { store: store, onResend: handleResend })))));
});
exports.default = SmsVerificationModal;
